import React, { FunctionComponent, useState } from 'react';

import {
  getDecodedStrippedString,
  getParsedHtml,
  HtmlParserType,
} from 'scenes/common/helpers/html';
import { DEFAULT_ONLINE_CAMPAIGN } from 'scenes/common/helpers/insuranceInfo';
import config from 'shared/config';

import {
  MarketingCampaignCard,
  HeaderMarketingCampaign,
} from './MarketingCampaignCard';

import MarketingCampaignModal from './MarketingCampaignModal';
import { MarketingCampaignProps } from './types';

export const shouldDisplayHeaderText = (pathname: string) => {
  const paths = [
    '/motor/overnight-parking',
    '/home/cover-type-selection',
    '/landlord/cover-type-selection',
  ];
  return paths.filter((path) => pathname.includes(path)).length > 0;
};

const MarketingCampaign: FunctionComponent<MarketingCampaignProps> = ({
  quoteNumber,
  headerDisplay,
  campaign,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  let descriptionElement: HtmlParserType;
  if (campaign) {
    descriptionElement = getParsedHtml(
      campaign.elements?.[0].description ?? ''
    );
  } else if (quoteNumber) {
    descriptionElement = (
      <strong>{DEFAULT_ONLINE_CAMPAIGN.descriptionAfterQuote}</strong>
    );
  } else {
    descriptionElement = (
      <strong>
        {headerDisplay
          ? DEFAULT_ONLINE_CAMPAIGN.description
          : DEFAULT_ONLINE_CAMPAIGN.desktopDescription}
      </strong>
    );
  }

  const termsModalHeadingElement: HtmlParserType = campaign ? (
    getParsedHtml(campaign.elements?.[0].description ?? '')
  ) : (
    <>{DEFAULT_ONLINE_CAMPAIGN.termsModalHeading}</>
  );

  const termsModalHeading: string = campaign
    ? getDecodedStrippedString(campaign.elements?.[0].description ?? '')
    : DEFAULT_ONLINE_CAMPAIGN.termsModalHeading;

  const { termsLinkText } = DEFAULT_ONLINE_CAMPAIGN;

  const disclaimerText: HtmlParserType = campaign
    ? getParsedHtml(campaign.disclaimer)
    : DEFAULT_ONLINE_CAMPAIGN.disclaimer;

  const imageUrl: string = campaign
    ? `${config.baseUrls.PEGA_CAMPAIGN_IMAGE_BASE_URL}/${
        campaign.elements?.[0]?.imageUrl ?? ''
      }`
    : DEFAULT_ONLINE_CAMPAIGN.image;

  return (
    <>
      {headerDisplay ? (
        <>
          <HeaderMarketingCampaign
            headerText={descriptionElement}
            subText={DEFAULT_ONLINE_CAMPAIGN.desktopDescription}
            shouldShowHeaderText={shouldDisplayHeaderText(
              window.location.pathname
            )}
            imageUrl={imageUrl}
            setIsModalOpen={() => setIsModalOpen(true)}
            campaign={campaign}
            termsLinkText={termsLinkText}
          />
        </>
      ) : (
        <>
          <MarketingCampaignCard
            quoteNumber={quoteNumber}
            headerText={descriptionElement}
            imageUrl={imageUrl}
            setIsModalOpen={() => setIsModalOpen(true)}
            campaign={campaign}
            termsLinkText={termsLinkText}
          />
        </>
      )}
      <MarketingCampaignModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        headerText={termsModalHeading}
        header={termsModalHeadingElement}
        disclaimerText={disclaimerText}
      />
    </>
  );
};

export default MarketingCampaign;
